import { flattenFieldErrors } from 'core/errors/mapFieldErrors';

export function ValidationSummary({ errors, title, fieldIds = {} }) {
  const items = flattenFieldErrors(errors);
  if (items.length === 0) {
    return null;
  }
  return (
    <div className="validation-summary" role="alert">
      <p>{title}</p>
      <ul>
        {items.map((item) => {
          const target = fieldIds[item.path] || item.path;
          return (
            <li key={`${item.path}-${item.message}`}>
              <a href={`#${target}`}>{item.message}</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export function focusFirstInvalid(errors, fieldIds = {}) {
  const first = flattenFieldErrors(errors)[0];
  if (!first) {
    return;
  }
  const id = fieldIds[first.path] || first.path;
  const node = document.getElementById(id);
  if (node && typeof node.focus === 'function') {
    node.focus();
    node.scrollIntoView({ block: 'center', inline: 'nearest' });
  }
}
